export class Location {
    id: number
    village?: string
    province?: string
    district?: string
    subDistrict?: string

    constructor(id: number, village: string, province: string, district: string, subDistrict: string) {
        this.id = id
        this.village = village
        this.province = province
        this.district = district
        this.subDistrict = subDistrict
    }
    
    address(): string {
        return `${this.village}, ${this.district}, ${this.province}`
    }

    static clone(l: Location): Location {
        return new Location(l.id, l.village, l.province, l.district, l.subDistrict)
    }

    static build(l: any): Location {
        if (l === null || l === undefined) {
            return null
        }
        return new Location(
            l.id,
            l.village,
            l.province,
            l.district,
            l.subdistrict ?? l.subDistrict)
    }
}